import axios from 'axios'
import { ADMIN_API_URL } from 'const'

const BASE_URL = `${ADMIN_API_URL}/staff`

export const listStaffMembers = async () => {
  try {
    const { data: staffMembers } = await axios.get(BASE_URL)
    return staffMembers
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}

export const createStaffMember = async (phoneNumber) => {
  try {
    const { data } = await axios.post(`${BASE_URL}/${phoneNumber}`)
    return data
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}

export const deleteStaffMember = async (userId) => {
  try {
    await axios.delete(`${BASE_URL}/${userId}`)
    return null
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}

// Every staff member with their live mic state, read off the heartbeat
// lease: recording true (live), false (stopped or quiet past the grace)
// or null (never beaten). Staff-only, about staff only.
export const getPresence = async () => {
  try {
    const { data } = await axios.get(`${BASE_URL}/presence`)
    return data
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}

// Push "turn on your mic!" to one staff member's phone. 404 unless the
// target is staff, so a poke can never reach a user.
export const poke = async (userId) => {
  try {
    const { data } = await axios.post(`${BASE_URL}/${userId}/poke`)
    return data
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}
